export const Scaduta = (dateString) => {
    // Controlla il formato della stringa usando una regex
    var regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) {
        return false; // Formato non valido
    }

    // Converte la stringa in oggetto Date
    var inputDate = new Date(dateString);
    if (isNaN(inputDate.getTime())) {
        return false; // Data non valida
    }

    // Calcola la data di oggi a mezzanotte
    var today = new Date();
    today.setHours(0, 0, 0, 0);

    // Confronta se la data è già passata
    return inputDate < today;
};

export const DataMinoreDiOggi = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) return false;

    const [year, month, day] = dateString.split("-").map(Number);
    const inputDate = new Date(year, month - 1, day);

    if (isNaN(inputDate.getTime())) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return inputDate <= today;
};

export const isOggi = (data: Date | string ) => {
    if (!data) {
        return false;
    }

    const inputDate = new Date(data);

    // 3. Check if the resulting object is a valid date (in case the string was unparsable)
    if (isNaN(inputDate.getTime())) {
        console.error('Invalid date format passed to isOggi:', data);
        return false;
    }

    // --- The original logic for comparison ---

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    inputDate.setHours(0, 0, 0, 0);

    return inputDate.getTime() === today.getTime();
};

export const ScadutaConOrario = (dateString) => {

    // Converte la stringa in oggetto Date
    var inputDate = new Date(dateString);
    if (isNaN(inputDate.getTime())) {
        return false; // Data non valida
    }

    // Calcola la data di oggi
    var today = new Date();

    // Confronta se la data è già passata
    return inputDate < today;
};

export const isDateAfterToday = (dateString: string) => {
    var inputDate = new Date(dateString);
    if (isNaN(inputDate.getTime())) {
        return false; // Data non valida
    }
    var today = new Date();
    return inputDate > today;
};


export const isDateNearExpiry = (dateString, daysUntilExpiry) => {
    // Controlla il formato della stringa usando una regex
    var regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) {
        return false; // Formato non valido
    }

    // Converte la stringa in oggetto Date
    var inputDate = new Date(dateString);
    if (isNaN(inputDate.getTime())) {
        return false; // Data non valida
    }

    // Calcola la data di oggi
    var today = new Date();

    // Calcola la differenza in giorni
    var differenceInTime = inputDate.getTime() - today.getTime();
    var differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));

    // Verifica se la data è prossima alla scadenza
    return differenceInDays <= daysUntilExpiry && differenceInDays >= 0;
};

export const Ieri = () => {
    var data = new Date();
    data.setDate(data.getDate() - 1);
    return data;
}
export const DateAddDays = (data: Date, days: number) => {
  data.setDate(data.getDate() + days);
  return data;
}
export const Oggi = () => {
    var data = new Date();
    return data
}
export const OggiString = () => {
  return `${Oggi().toISOString().slice(0,10)}`;
}
export const OggiPlus = (num) => {
    var data = new Date();
    data.setDate(data.getDate() + num);
    return data
}

export const PrimoDelMese = (anno?, mese?) => {
    var data = new Date();
    data.setDate(data.getDate() - 10); // in modoi da avere anche il mese precedente se sono a inizio mese
    return new Date(anno ?? data.getFullYear(), (mese ?? data.getMonth()), 1);
}
export const UltimoDelMese = (anno?, mese?) => {
    var data = new Date();
    return new Date(anno ?? data.getFullYear(), (mese? (mese + 1) : (data.getMonth() + 1)), 0);
}
export const PrimoDelMeseString = (anno?, mese?) => {
    var data = PrimoDelMese(anno, mese);
    return `${data.toISOString().slice(0, 10)}`;
}
export const UltimoDelMeseString = (anno?, mese?) => {
    var data = UltimoDelMese(anno, mese);
    return `${data.toISOString().slice(0,10)}`;
}
export const Anno = () => {
    var data = new Date();
    return data.getFullYear();
}
export const MeseCorrente = () => {
    var data = new Date();
    return data.getMonth();
}

export const getWeekDay = (date: Date) => {
    var day = date.getDay();
    return day === 0 ? 7 : day;
}

export const getWeekDayFromString = (date: string) => {
    return getWeekDay(new Date(date));
}
export const getWeekDayObj = (date: Date, festivo: number[]) => {
    var day = getWeekDay(date);
    return {
        day: day,
        dayName: ['Lunedi', 'Martedi', 'Mercoledi', 'Giovedi', 'Venerdi', 'Sabato', 'Domenica'][day - 1],
        dayShortName: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'][day - 1],
        date: date,
        Festivo: festivo.some(festivo => festivo == day)
    };
}

export const getWeekDayObjFromString = (date: string, festivo: number[]) => {
    return getWeekDayObj(new Date(date), festivo);
}

export const isBetween = (date: Date, start: Date, end: Date) =>{
    return date >= start && date <= end;
}

export const isBetweenString = (date: string, start: string, end: string) => {
    var inizio = `${start.split('T')[0]}T00:00`;
    var fine = `${end.split('T')[0]}T23:59`;
    return isBetween(new Date(date), new Date(inizio), new Date(fine));
}

export const DateToString = (date: Date) => {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
}
export const DateToDateTimeString = (date: Date) => {
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}T${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
}

export const dateTimeStringToFormattedDateTime = (dateTimeString: string) => {
    var date = new Date(dateTimeString);
    return dateTimeString ? `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`: null;
}
export const getDateYear = (dateTimeString:string)=>{
  var date = new Date(dateTimeString);
  return date.getFullYear();
}

export const todayDateString = () => {
    const oggi = new Date();
    const yyyy = oggi.getFullYear();
    const mm = String(oggi.getMonth() + 1).padStart(2, '0');
    const dd = String(oggi.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}


export const dateTimeStringToFormattedDate = (dateTimeString: string) => {
    var date = new Date(dateTimeString);
    return dateTimeString ? `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}` : null;
}
